<script lang="ts">
		import type { BasicContent } from '$lib/domain/basic-content.interface';
		import Accordion from './Accordion.svelte';

		export let faq: BasicContent[] = [];
</script>

<div class="faq  flex-column">
	<div class="section-title">
		<h2>Frequently asked questions</h2>
		
		<div class="green-line"></div>
	</div>
	
	<div class="faq-accordeon flex-column">
		<Accordion faq="{faq}" />
	</div>
</div>

<style lang="scss">
  @import '$styles/vars';

  .faq {
	padding-top: 60px;
	min-width: 100%;

	&-accordeon {
	  margin-top: 60px;
	}
  }

	@media (max-width: $portrait-phone-size) {
		.faq {
		  padding-top: 36px;

			&-accordeon {
				margin-top: 36px;
			}
		}
	}
</style>
